import { useMemo } from 'react';
import type React from 'react';

import { Avatar } from '@change-corgi/design-system-legacy/components/media';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import type { DecisionMaker } from 'src/app/shared/hooks/decisionMakers';

type Props = {
	decisionMaker: DecisionMaker;
};

export const DecisionMakerResult: React.FC<Props> = ({ decisionMaker }) => {
	const photoUrl = useMemo(() => {
		if (decisionMaker.photo?.userSmall.url) {
			return decisionMaker.photo.userSmall.url;
		}

		if (decisionMaker.isPerson) {
			return 'https://static.change.org/profile-img/default-user-profile.svg';
		}
		// FIXME find a better default avatar for orgs
		return 'https://static.change.org/profile-img/default-org-profile.svg';
	}, [decisionMaker]);

	return (
		<Box sx={{ border: 'none', borderRadius: 0, display: 'inline-flex', alignItems: 'center' }}>
			<Avatar alt="avatar" size="s" src={photoUrl} margin={4} />
			<Flex margin={4} sx={{ flexDirection: 'column', alignItems: 'flex-start', lineHeight: '1' }}>
				<Text sx={{ fontWeight: 'bolder' }}>{decisionMaker.displayName}</Text>
				<Text color="neutral-grey600" sx={{ fontWeight: 'normal' }}>
					{decisionMaker.summary}
				</Text>
			</Flex>
		</Box>
	);
};
